export enum MapPaneIndex {
    MARKER = '501',
    VEHICLES = '500',
    OVERLAY = '499',
    STATIONS = '498',
    GEOFENCING_ZONES = '497',
    BACKGROUND = '496',
    LOCAL_AUTHORITIES = '200'
}
